export default __webpack_public_path__ + "static/media/ynet.f2152248.svg";